import tseInstance from '../instance'

const getTseNullOrders = () => {
	return tseInstance.get('/nullOrders')
}

export default getTseNullOrders
